import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-safe-shopping-tips",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-qc-inspection-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-shipping-cost-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-budget-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-top-finds-june-2026",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-haul-review-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-best-sneaker-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-streetwear-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-size-conversion-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-seller-verification-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-custom-order-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-agent-comparison-guide",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;